// extracted by mini-css-extract-plugin
export default {"spinner":"SpinnerWhite_spinner__OX8H8","spinner1":"SpinnerWhite_spinner1__7tt1z","spinner2":"SpinnerWhite_spinner2__LTB6x","spinner3":"SpinnerWhite_spinner3__bRnhO"};